import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { CaseTypesState } from "@vp/data-access/case-types";
import { CaseType } from "@vp/models";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Pipe({
  name: "caseTypeDisplay",
  standalone: false
})
export class CaseTypeDisplayPipe implements PipeTransform {
  allCaseTypes$: Observable<CaseType[]> = inject(Store).select(CaseTypesState.allCaseTypes);

  transform(caseTypeId: string): Observable<string> {
    return this.allCaseTypes$.pipe(
      shareReplay(),
      map((caseTypes: CaseType[]) => {
        const caseType = caseTypes.find(c => c.caseTypeId === caseTypeId);
        return caseType?.displayName ?? "[caseType not found]";
      })
    );
  }
}
